import {render} from 'preact';
import {jsonData} from '../data/data.js';
import WidgetComponent from '../components/widget';
import WidgetModel from '../model/widget';
import ProgressModule from '../moduls/progress';
import ShareComponent from '../components/share';
import Timer from '../components/timer';
import Constitution from '../components/constitution';

const OBJECT_FROM_WINDOW_NAME = `MKWidgetPolls`;
const DEFAULT_WIDGET_PLACE = `test-mk-wiget-polls`;

const nextBrunches = function (root, modelData) {
  const result = []
  if (modelData.steps.has(root)){
    if (`next` in modelData.steps.get(root)) {
      result.push(modelData.steps.get(root).next);
    }
    if (`answers` in modelData.steps.get(root)) {
      modelData.steps.get(root).answers.forEach((element) => {
        if (`next` in element) {
          result.push(element.next);
        }
      });
    }
    const resultSet = new Set(result);
    resultSet.delete(root);
    return Array.from(resultSet);
  }
  return [];
};

const toTree = function(modelData, start, ban = []) {
  const banSet = new Set(ban);
  const nextBrunchesArray = nextBrunches(start, modelData).map((element) => {
    if (!banSet.has(element)){
      return toTree(modelData, element, [...ban, start]);
    }
  });
  const str = (Array.isArray(nextBrunchesArray) && (nextBrunchesArray.length > 1)) ? `[${nextBrunchesArray.join(', ')}]` : nextBrunchesArray[0];
  return (str) ? `${start} -> ${str}` : `${start}`;
};

/**********************************************************/

export default class Loader {
  static start() {
    const modelData = [];
    const progress = [];
    const responseData = Loader.loadData();
    responseData.forEach((dataElement) => {
      const modelDataElement = new WidgetModel(dataElement);
      modelData.push(modelDataElement);
      progress.push(new ProgressModule(modelDataElement.start, dataElement.steps));
    });

    render(<ShareComponent />, document.querySelector('.share'));
    // render(<Timer />, document.querySelector('.content-head__timer'));
    render(<Constitution />, document.querySelector('.content-body'));

    const widgets = (OBJECT_FROM_WINDOW_NAME in window) ? window.MKWidgetPolls : [];
    widgets.forEach((widget, index) => {
      const selector = ('place' in widget) ? `#${widget.place}` : `#${DEFAULT_WIDGET_PLACE}`;
      render(<WidgetComponent data={modelData[index]} progress={progress[index]}/>, document.querySelector(selector));
    });

    const games = document.querySelector('.content-body__game-list');
    const gameItems = games.querySelectorAll('.content__game');
    const buttons = games.querySelectorAll('.content-body__button');
    const gameControlButtons = document.querySelectorAll('.footer__controls-button');
    const scrollLeft = document.querySelector('.content-body__slider-button_back');
    const scrollRight = document.querySelector('.content-body__slider-button_forward');
    const steps = games.querySelectorAll('.content__step');
    const gameViewPort = document.querySelector('.main');

    const switchGame = (evt, button, gameIndex, game) => {
      evt.preventDefault();
      gameItems.forEach((element) => element.classList.add('js-hidden'));
      buttons.forEach((element) => element.classList.remove('content-body__button_active'));
      gameControlButtons.forEach((element) => element.classList.remove('footer__controls-button_active'));
      button.classList.add('content-body__button_active');
      gameControlButtons[gameIndex].classList.add('footer__controls-button_active');
      game.classList.remove('js-hidden');

      games.scrollTo(buttons[gameIndex].offsetLeft - ((gameViewPort.offsetWidth - buttons[gameIndex].offsetWidth - steps[gameIndex].offsetWidth) / 2), 0);

      if (document.documentElement.clientWidth < 710) {
        document.querySelector('.footer').style.marginTop = `${steps[gameIndex].scrollHeight}px`;
      }
    }

    buttons[0].addEventListener('click', function(evt) {
      const button = this;
      switchGame(evt, button, 0, gameItems[0]);
    });

    buttons[1].addEventListener('click', function(evt) {
      const button = this;
      switchGame(evt, button, 1, gameItems[1]);
    });

    buttons[2].addEventListener('click', function(evt) {
      const button = this;
      switchGame(evt, button, 2, gameItems[2]);
    });

    gameControlButtons.forEach((button, index) => button.addEventListener('click', function() {
      buttons[index].click();
    }));

    scrollLeft.addEventListener('click', function() {
      games.scrollBy(-50,0);
    });

    scrollRight.addEventListener('click', function() {
      games.scrollBy(50,0);
    });
  }

  static loadData() {
    return JSON.parse(jsonData);
  }
}



// WEBPACK FOOTER //
// ./moduls/loader.js